import axios from 'axios';
// import qs from 'qs'
import Vue from 'vue';
import storage from '@/utils/localStorage'
import utils from '@/utils/utils'

let loginFlag = true;
let deviceId = storage.get('device_id')
if (deviceId == null) {
  deviceId = utils.getDeviceId()
  storage.set('device_id', deviceId)
}

// 創建axios实例
const service = axios.create({
  baseURL: window.apiUrl,
  timeout: 5000,
});

service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
service.interceptors.request.use((config) => {
  if (config.method === 'post') {
    config.data = {
      ...config.data,
      format: 'json',
    };
  } else if (config.method === 'get') {
    config.params = {
      ...config.params,
      format: 'json',
    };
  }
  config.withCredentials = true;

  return config;
}, (error) => Promise.reject(error));
service.interceptors.response.use((response) => {
  if (loginFlag) {
    if (response.data.code === 1002) {
      loginFlag = false;
      Vue.prototype.showNotify('失敗', '登入已過期，請重新登入！', 'error', () => {
        location.href = process.env.VUE_APP_BASE_API;
      });
    }
  }
  return response;
}, (error) => Promise.resolve(error.response));

export default service;
